import { heroInfo } from "@/mocks/home";

export default function HeroCover() {
  return (
    <section id="top" className="w-full px-4 md:px-6 pt-10 md:pt-16 pb-12 md:pb-20">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between border-b border-foreground-950 pb-3 mb-8 md:mb-12">
          <span className="font-heading text-xs md:text-sm tracking-[0.2em] text-foreground-700">
            本期封面 · COVER
          </span>
          <span className="font-label text-xs md:text-sm text-foreground-500">
            {heroInfo.issue}
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center">
          <div className="lg:col-span-7">
            <p className="font-heading text-sm md:text-base text-primary-700 mb-4">
              {heroInfo.kicker}
            </p>
            <h2 className="font-heading text-3xl md:text-5xl lg:text-[3.3rem] leading-[1.16] font-black text-foreground-950 mb-6">
              {heroInfo.title}
            </h2>
            <p className="text-sm md:text-base leading-7 md:leading-8 text-foreground-600 max-w-xl mb-9">
              {heroInfo.lead}
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-10">
              <a
                href="#entry"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                {heroInfo.primaryCta}
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#condensed"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-foreground-300 text-foreground-800 text-sm font-label whitespace-nowrap hover:border-foreground-800 transition-colors cursor-pointer"
              >
                {heroInfo.secondaryCta}
              </a>
            </div>

            <div className="flex flex-wrap gap-x-10 gap-y-5">
              {heroInfo.stats.map((stat) => (
                <div key={stat.label}>
                  <p className="font-heading text-2xl text-foreground-950">
                    {stat.value}
                  </p>
                  <p className="mt-1 text-xs text-foreground-500 font-label">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20paper%20collage%20art%20print%20with%20overlapping%20torn%20paper%20layers%20in%20warm%20off-white%2C%20muted%20crimson%20and%20amber%20accents%2C%20subtle%20grain%20texture%2C%20geometric%20composition%20with%20generous%20negative%20space%2C%20calm%20quiet%20magazine%20cover%20aesthetic%2C%20soft%20studio%20lighting%2C%20high%20detail&width=900&height=1200&seq=heiao-cover-01&orientation=portrait"
                alt="黑料视频合集封面配图 本期主题"
                title="黑料视频合集封面配图 本期主题"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 via-transparent to-transparent" />
              <p className="absolute bottom-4 left-4 right-4 font-heading text-sm text-background-50">
                {heroInfo.date} · 封面配图
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}